import VuexORM from '@vuex-orm/core';

import PaymentPolicy from '@/models/PaymentPolicy';
import CancellationPolicy from '@/models/CancellationPolicy';
import MealPlan from '@/models/MealPlan';
import RatePlan from '@/models/RatePlan';
import RatePlanExtra from '@/models/RatePlanExtra';
import Room from '@/models/Room';
import Hotel from '@/models/hotels/Hotel';
import HotelAmenities from '@/models/hotels/HotelAmenities';
import HotelSearch from '@/models/hotels/HotelSearch';
import Checkout from '@/models/user/Checkout';
import Booking from '@/models/user/Booking';
import Voucher from '@/models/user/Voucher';
import Customer from '@/models/user/Customer';
import Extra from '@/models/Extra';
import Theme from '@/models/Theme';
import CheckoutExtra from '@/models/CheckoutExtra';
import BookingFee from '@/models/BookingFee';
import ExternalProduct from '@/models/ExternalProduct'
import AlternateHotel from '@/models/hotels/AlternateHotel';
import AgeGroupPolicy from '@/models/AgeGroupPolicy';
import AgeGroup from '@/models/AgeGroup';
import RatePlanPrice from '@/models/RatePlanPrice';
import AgeGroupPrice from '@/models/AgeGroupPrice';
import Configuration from '@/models/Configuration';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import axios from 'axios';
import SpecialWish from '@/models/user/SpecialWish';
import DateSearch from '@/models/DateSearch'
import Step from '@/models/app/Step'
import SpecialOffer from '@/models/SpecialOffer'
import Fee from '@/models/Fee'
import TotalPrice from '@/models/TotalPrice'
import PaymentMethods from '@/models/PaymentMethods'
import PhysicalRoom from '@/models/PhysicalRoom';
import config from '@/utils/config'
import Profile from '@/models/user/Profile';
import ConfigurationFee from "@/models/ConfigurationFee";
import RoomHotelAmenities from "@/models/hotels/RoomHotelAmenities"
import Country from "@/models/global/Country"

const database = new VuexORM.Database();
//basic token

VuexORM.use(VuexORMAxios, {
  axios,
  baseURL: config.apiUrl
});
// Register Models to Database.

database.register(RatePlanPrice);
database.register(RatePlanPrice);
database.register(SpecialOffer);
database.register(PaymentPolicy);
database.register(AgeGroupPolicy);
database.register(CancellationPolicy);
database.register(RatePlan);
database.register(RatePlanExtra);
database.register(AgeGroupPolicy);
database.register(MealPlan);
database.register(Room);
database.register(HotelAmenities);
database.register(HotelSearch);
database.register(Hotel);
database.register(Configuration);
database.register(AgeGroupPrice);
database.register(Checkout);
database.register(Booking);
database.register(Voucher);
database.register(SpecialWish)
database.register(Customer)
database.register(Extra)
database.register(Theme)
database.register(CheckoutExtra)
database.register(DateSearch)
database.register(Step)
database.register(Fee)
database.register(ConfigurationFee)
database.register(BookingFee)
database.register(TotalPrice)
database.register(PaymentMethods)
database.register(ExternalProduct);
database.register(PhysicalRoom);
database.register(AgeGroup);
database.register(Profile);
database.register(AlternateHotel);
database.register(RoomHotelAmenities);
database.register(Country);

export default database;
